import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { BlockScheduleModel, BlockScheduleStatus } from '../../models/blockschedule.model';
import { ProjectService } from '../../services/project.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-skidinfo',
 imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    TextareaModule,
    InputNumberModule,
    DatePickerModule,
    SelectModule,
    FieldsetModule,
    CheckboxModule
  ],
  templateUrl: './skidinfo.html',
  styleUrl: './skidinfo.css',
})
export class Skidinfo {
  blockScheduleForm!: FormGroup;
  blockScheduleData: BlockScheduleModel | null = null;

  igbtOptions = ['Mitsubishi', 'Infineon'];
  checkOptions = ['Yes', 'No'];
  skidConfigOptions = ['N1', 'N2', 'N3', 'N4', 'N5', 'N6'];
  shipStatusOptions = ['Delivered', 'Delayed'];
  skidStatusOptions = Object.values(BlockScheduleStatus);
  constructor(
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private projectService: ProjectService,
    private messageService: MessageService
  ) {

  }

  ngOnInit(): void {
    console.log('Blockschedule dialog data:', this.config.data);
    this.initializeForm(this.config.data?.skidData || null);
  }

  private initializeForm(data: BlockScheduleModel | null): void {
    console.log('Initializing form with data:', data);
    this.blockScheduleForm = this.fb.group({
      projectId: [data?.projectId || null],
      blockScheduleId: [data?.blockScheduleId],
      shipDate: [data?.shipDate ? new Date(data.shipDate) : new Date()],
      arrivalDate: [data?.arrivalDate ? new Date(data.arrivalDate) : null],
      tmeicSkidNo: [data?.tmeicSkidNo],
      integratorSkidSerialNo: [data?.integratorSkidSerialNo || ''],
      customerSkidNumber: [data?.customerSkidNumber || ''],
      skidConfiguration: [data?.skidConfiguration || ''],
      billoflading: [data?.billoflading || ''],
      appointmentTime: [data?.appointmentTime ? new Date(data.appointmentTime) : null],
      overWeight: [data?.overWeight || false],
      overDimension: [data?.overDimension || false],
      logisticsComment: [data?.logisticsComment || ''],
      deliveryDate: [data?.deliveryDate ? new Date(data.deliveryDate) : null],
      shippingStatus: [data?.shippingStatus || ''],
      inv1SerialNo: [data?.inv1SerialNo || ''],
      inv2SerialNo: [data?.inv2SerialNo || ''],
      inv3SerialNo: [data?.inv3SerialNo || ''],
      inv4SerialNo: [data?.inv4SerialNo || ''],
      inv5SerialNo: [data?.inv5SerialNo || ''],
      inv6SerialNo: [data?.inv6SerialNo || ''],
      inv7SerialNo: [data?.inv7SerialNo || ''],
      inv1Igbt: [data?.inv1Igbt || ''],
      inv2Igbt: [data?.inv2Igbt || ''],
      inv3Igbt: [data?.inv3Igbt || ''],
      inv4Igbt: [data?.inv4Igbt || ''],
      inv5Igbt: [data?.inv5Igbt || ''],
      inv6Igbt: [data?.inv6Igbt || ''],
      inv7Igbt: [data?.inv7Igbt || ''],
      scu: [data?.scu || ''],
      dis: [data?.dis || ''],
      epanb: [data?.epanb || ''],
      dcFuses: [data?.dcFuses || ''],
      estimatedDeliveryDate: [data?.estimatedDeliveryDate ? new Date(data.estimatedDeliveryDate) : null],
      mvXfmrDesign: [data?.mvXfmrDesign || ''],
      mvXfmrSerialNo: [data?.mvXfmrSerialNo || ''],
      lvXfmrSerialNo: [data?.lvXfmrSerialNo || ''],
      bushingSize: [data?.bushingSize || null],
      scadaSerialNo: [data?.scadaSerialNo || ''],
      trackerSerialNo1: [data?.trackerSerialNo1 || ''],
      trackerSerialNo2: [data?.trackerSerialNo2 || ''],
      wildlifeRepellentAdded: [data?.wildlifeRepellentAdded || ''],
      wildlifeWarningLabelApplied: [data?.wildlifeWarningLabelApplied || ''],
      notes: [data?.notes || ''],
      skidStatus: [data?.skidStatus || ''],
      createdBy: [null],
      createdDate: [data?.createdDate || null],
      updatedBy: [null],
      updatedDate: [data?.updatedDate || null]
    });
  }

  onSubmit(): void {
    if (this.blockScheduleForm.valid) {
      const formValue = this.blockScheduleForm.value;
      const updatedBlockSchedule: BlockScheduleModel = {
        ...formValue,
        updatedAt: new Date(),
        // Add any additional processing here
      };

      console.log('Saving block schedule:', updatedBlockSchedule);

      // Simulate API call
      this.projectService.updateBlockSchedule(updatedBlockSchedule).subscribe(() => {
        console.log('Block schedule updated successfully');
        this.ref.close(updatedBlockSchedule);
      });
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.blockScheduleForm.controls).forEach(key => {
        this.blockScheduleForm.get(key)?.markAsTouched();
      });
    }
  }

  onCancel(): void {
    this.ref.close();
  }

  private handleLoadingError(message: string) {
    console.log(message);
    // You can add toast notifications or other error handling here
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }
}
